import React, { useState } from "react";
import { AiFillHome } from "react-icons/ai";
import { FaSearch } from "react-icons/fa"
import { IoMdInformationCircle } from "react-icons/io";
import { MdAccountCircle, MdShoppingCart } from "react-icons/md";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { searchToggle } from "../redux/shopSlice"

function NavBarBottom () {
  const productData = useSelector((state) => state.shopsyReducer.productData);
  console.log(productData);

// SET SEARCHBAR TOGGLE
  const loco = useLocation().pathname
  console.log(loco);
  const [toggle,setToggle] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleToggle = () =>  {
    setToggle(true)
    dispatch(searchToggle({ toggleOn: toggle }));
    console.log(toggle)
    if(loco!=="/" && toggle){
      console.log("Away")
      navigate('/')
    }
    if(loco==="/"&&toggle){
      setToggle(false)
    }
  }

  return (
    <div>
      <div className="w-screen">
        {/* <section id="bottom-navigation" className="md:hidden block fixed inset-x-0 bottom-0 z-10 bg-white shadow"> // if shown only tablet/mobile */}
        <section
          id="bottom-navigation"
          className="block fixed inset-x-0 bottom-0 z-10 bg-slate-900 shadow rounded-t-3xl py-2"
        >
          <div
            id="tabs"
            className="flex justify-between text-slate-400 font-semibold font-bodyFont"
          >
            <p className="w-full  focus:text-violet-400 hover:text-violet-400 hover:scale-110 duration-200 justify-center inline-block text-center pt-2 pb-1">
              <Link to={"/"} className="cursor-default">
                <div>
                  <AiFillHome
                    style={{
                      marginLeft: "auto",
                      marginRight: "auto",
                      fontSize: "25px",
                    }}
                  />
                  <span className="tab tab-home block text-xs"> Home</span>
                </div>
              </Link>
            </p>

            <p className="w-full focus:text-violet-400 hover:scale-110 duration-200 hover:text-violet-400 justify-center inline-block text-center pt-2 pb-1">
              <Link to={"/info"}>
                <IoMdInformationCircle
                  style={{
                    marginLeft: "auto",
                    marginRight: "auto",
                    fontSize: "25px",
                  }}
                />
                <span className="tab tab-explore block text-xs">Info</span>
              </Link>
            </p>
            <p className="w-full focus:text-violet-400 hover:scale-110 duration-200 hover:text-violet-400 justify-center inline-block text-center pt-2 pb-1">
              <FaSearch
                style={{
                  marginLeft: "auto",
                  marginRight: "auto",
                  fontSize: "25px",
                }}
                onClick={handleToggle}
              />
              <span className="tab tab-kategori block text-xs">Search</span>
            </p>

            <p className="w-full focus:text-violet-400 hover:text-violet-400 hover:scale-110 duration-200 justify-center inline-block text-center cursor-pointer pt-2 pb-1">
              <Link to={"/account"}>
                <div>
                  <MdAccountCircle
                    style={{
                      marginLeft: "auto",
                      marginRight: "auto",
                      fontSize: "25px",
                    }}
                  />
                  <span className="tab tab-whishlist block text-xs">
                    Account
                  </span>
                </div>
              </Link>
            </p>

            <p className="w-full focus:text-violet-400 hover:text-violet-400 hover:scale-105 duration-200 justify-center inline-block text-center pt-2 pb-1 group">
              <Link to={"/cart"}>
                <div>
                  <MdShoppingCart
                    style={{
                      marginLeft: "auto",
                      marginRight: "auto",
                      fontSize: "25px",
                    }}
                  />
                  <span className="absolute text-slate-800 bg-purple-400 rounded-full h-4 w-4 right-5 bottom-11 group-hover:bottom-10 xl:right-28 lg:right-20 md:right-14 text-xs flex items-center justify-center font-semibold">
                    {productData.length}
                  </span>
                  <span className="tab tab-account block text-xs">Cart</span>
                </div>
              </Link>
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default NavBarBottom;
